// services/participantServices/ParticipantSearchService.ts

export type ParticipantSearchQuery = {
  searchTerm?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDesc?: boolean;
};

export type ParticipantSearchItem = {
  id: number;
  firstName: string;
  lastName: string;
  email?: string | null;
  regionId: number;
  deactivated: boolean;
  creationDate?: string | null;
  waiverName?: string | null;
  caseworker?: {
    id: string;
    displayName: string;
  } | null;
};

export type ParticipantSearchResponse = {
  participants: ParticipantSearchItem[];
  totalCount: number;
};

export async function searchParticipants(
  authToken: string,
  query: ParticipantSearchQuery
): Promise<ParticipantSearchResponse> {
  const base = process.env.REACT_APP_API_BASE_URL;
  const params = new URLSearchParams();

  if (query.searchTerm) params.set("searchTerm", query.searchTerm);
  params.set("page", String(query.page ?? 1));
  params.set("pageSize", String(query.pageSize ?? 10));
  if (query.sortBy) params.set("sortBy", query.sortBy);
  if (typeof query.sortDesc === "boolean") params.set("sortDesc", String(query.sortDesc));

  const url = `${base}/search/participant?${params.toString()}`;

  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!res.ok) {
    // Normalize failures to an empty result so callers don’t crash
    return { participants: [], totalCount: 0 };
  }

  const json = (await res.json()) as ParticipantSearchResponse;
  // basic shape-guard
  if (!json || !Array.isArray(json.participants) || typeof json.totalCount !== "number") {
    return { participants: [], totalCount: 0 };
  }
  return json;
}
